import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';
import { INSTANT_GAME_TYPE, DRAW_GAME_TYPE } from 'app/config/gametype';

const CONTEXT = 'dashboard';

const getBigWinnersUrl = (gameType) => {
  switch (gameType) {
    case INSTANT_GAME_TYPE: {
      return DepsService.rest.widgets.bigWinnersScratch.url;
    }
    case DRAW_GAME_TYPE: {
      return DepsService.rest.widgets.bigWinnersOnline.url;
    }
    default:
      return DepsService.rest.widgets.bigWinners.url;
  }
};

export const fetchBigWinners = (retailerId, gameType) => {
  const url = getBigWinnersUrl(gameType);
  const queryParams = {};
  const urlParams = { retailerId };
  const path = 'widgets.bigWinners';

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams, path);
};

export const fetchBigWinnersHistory = (queryParams, retailerId) => {
  const { url } = DepsService.rest.widgets.bigWinnersHistory;
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const downloadBigWinnersHistoryReport = (queryParams, retailerId, extension) => {
  const { url } = DepsService.rest.widgets.bigWinnersHistory;
  const urlParams = { retailerId };
  const headers = appHelpers.setHeader(extension);

  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams, headers);
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/big-winners.api.js